import history from '../history';

// import isValidEmail from '../utils/isValidEmail';

// export const UPDATE_USER_INFO_START = 'UPDATE_USER_INFO_START';
// export const UPDATE_USER_INFO_SUCCESS = 'UPDATE_USER_INFO_SUCCESS';
// export const UPDATE_USER_INFO_ERROR = 'UPDATE_USER_INFO_ERROR';

// export const updateUser = function(userProfileData) {
// 	return dispatch => {
// 		dispatch({ type: UPDATE_USER_INFO_START });
//
// 		// normally api call
// 		setTimeout(() => {
// 			if (userProfileData.firstName.length > 0 && isValidEmail(userProfileData.email)) {
// 				dispatch({ type: UPDATE_USER_INFO_SUCCESS, data: userProfileData });
// 			} else {
// 				dispatch({ type: UPDATE_USER_INFO_ERROR });
// 			}
// 		}, 500);
// 	}
// }

// export const SET_CURRENT_QUIZ = 'SET_CURRENT_QUIZ';

// export const setAndStartCurrentQuiz = function(quiz) {
// 	return dispatch => {
// 		dispatch({ type: SET_CURRENT_QUIZ, data: quiz });
//
// 		history.push(`/quiz/${quiz.id}/start`);
// 	}
// }

export const ADD_ANSWER = 'ADD_ANSWER';

export const answerQuestion = function(answer, quiz, questionID) {
	return dispatch => {

		let newQuestId = parseInt(questionID, 10) + 1;

		dispatch({ type: ADD_ANSWER, data: { answer, quiz, questionID } });

		if (quiz.questions.length > parseInt(questionID, 10)) {
			history.push(`/quiz/${newQuestId}`);
		} else {
			history.push(`/profile`);
		}
	};
}



// WEBPACK FOOTER //
// ./src/actions/quiz.js